module.exports = __webpack_public_path__ + "static/media/ducks.7cfd4907.jpg";